import { useState } from "#app";
const useUserAuth = () => {
  const userAuthData = useState("userAuth", () => {
  });
  const setUserAuthData = (user) => {
    userAuthData.value = user;
  };
  return {
    userAuthData,
    setUserAuthData
  };
};
export default useUserAuth;
